import { useMutation } from '@tanstack/react-query';
import { IEmbedV4 } from '@opengov/reporting-types';
import { save as saveEmbedSDK } from '@opengov/reporting-embeds';

import { useToast } from '../../../../stories/components/Toast/context/useToast.context';
import { embedPickerQueryKeys } from './embedPickerQueryKeys';

export type CreateV4EmbedVariables = {
  id?: string;
  title: string;
  description: string;
  reportId: string;
  savedViewId: string;
  shouldSync: boolean;
  reportVersion: string;
  type: string;
  data?: any;
  controller?: AbortController;
};

export function useCreateV4Embed() {
  const { toggleToast } = useToast();

  return useMutation<IEmbedV4, Error, CreateV4EmbedVariables>({
    mutationKey: [...embedPickerQueryKeys.all, 'createV4Embed'],
    mutationFn: async ({ controller, ...payload }) => {
      const result = await saveEmbedSDK({ ...payload, version: 'v4' }, controller);
      if (!result?.id) {
        throw new Error('Could not create embed');
      }
      return result as IEmbedV4;
    },
    onError: () => {
      toggleToast({ title: 'Could not create embed', severity: 'error' });
    }
  });
}
